import React from 'react'
import MainPaper from 'src/features/Components/MainPaper'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { TextField } from 'final-form-material-ui'
import Button from '@material-ui/core/Button'
import { KeyboardDatePicker } from '@material-ui/pickers'
import styled from 'styled-components'
import { Form, Field } from 'react-final-form'
import { createPromo, fetchDetail } from '../ducks'
import { useDispatch, useSelector } from 'react-redux'
import InputAdornment from '@material-ui/core/InputAdornment'
import useNotification from 'src/features/Notification/customs'
import get from 'lodash/get'
import moment from 'moment'

const useStyles = makeStyles((theme) => ({
  root: { height: '100%' },
  title: { marginBottom: theme.spacing(2) },
  to_text: { marginTop: theme.spacing(4) },
  btn: {
    width: 120,
    height: 44,
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
    borderRadius: 20,
  },
}))

const required = (value) => (value ? undefined : 'The field is required.')

const not_past = (value) => {
  return moment().isBefore(moment(value)) ? undefined : "The date can't be past days"
}
const start_date = (value, allValues) =>
  moment(value).isAfter(moment(allValues.end_date)) ? "Start date can't be more later to end date." : undefined
const end_date = (value, allValues) =>
  moment(value).isBefore(moment(allValues.start_date)) ? "End date can't be more earier to start date." : undefined

const isNumber = (value) =>
  !!value ? (Number.isInteger(parseInt(value)) ? undefined : 'This field must be an number.') : undefined
const composeValidators = (...validators) => (value, allValues) =>
  validators.reduce((error, validator) => error || validator(value, allValues), undefined)

const StyledDate = styled(KeyboardDatePicker)`
  div {
    height: 44px !important;
  }
`
const StyledPrice = styled(TextField)`
  div {
    height: 44px !important;
  }
`

const customDateInput = (props) => {
  return (
    <StyledDate
      clearable
      disablePast
      initialFocusedDate={moment().add(1, 'days')}
      inputVariant="outlined"
      format="dd/MM/yyyy"
      {...props.input}
      value={props.input.value || null}
      error={props.meta.touched && !!props.meta.error}
      helperText={props.meta.touched && !!props.meta.error && props.meta.error}
    />
  )
}

function Index() {
  const classes = useStyles()
  const dispatch = useDispatch()
  const detail = useSelector((state) => state.medicine.detail)
  const { showError, showSuccess } = useNotification()

  return (
    <Form
      initialValues={{
        package_medicine: get(detail, '_id', ''),
        start_date: null,
        end_date: null,
        promo_price: null,
      }}
      onSubmit={async (values) => {
        try {
          await dispatch(createPromo(values))
          await dispatch(fetchDetail(detail._id))
          showSuccess()
        } catch (error) {
          error.forEach((item) => {
            showError(item.message)
          })
          throw error
        }
      }}
      subscription={{
        submitting: true,
        pristine: true,
        valid: true,
      }}
    >
      {({ handleSubmit, form: { reset }, valid }) => {
        return (
          <form
            onSubmit={async (e) => {
              try {
                await handleSubmit(e)
                if (valid) {
                  reset()
                }
              } catch (error) {}
            }}
          >
            <MainPaper elevation={0} className={classes.root}>
              <Typography className={classes.title}>ADD NEW PROMOTION</Typography>
              <Grid container spacing={2}>
                <Grid item>
                  <Typography variant="body2" gutterBottom>
                    Start Date:
                  </Typography>
                  <Field
                    name="start_date"
                    type="select"
                    validate={composeValidators(required, not_past, start_date)}
                    render={customDateInput}
                  />
                </Grid>
                <Grid item>
                  <Typography className={classes.to_text}>To</Typography>
                </Grid>
                <Grid item>
                  <Typography variant="body2" gutterBottom>
                    End Date:
                  </Typography>
                  <Field
                    name="end_date"
                    type="select"
                    validate={composeValidators(required, not_past, end_date)}
                    render={customDateInput}
                  />
                </Grid>
                <Grid item>
                  <Typography variant="body2" gutterBottom>
                    *Price (+VAT):
                  </Typography>
                  <Field
                    name="promo_price"
                    validate={composeValidators(required, isNumber)}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">‎฿</InputAdornment>,
                    }}
                    variant="outlined"
                    component={StyledPrice}
                  />
                </Grid>
                <Grid item>
                  <Button variant="contained" color="primary" type="submit" className={classes.btn} disableElevation>
                    add
                  </Button>
                </Grid>
              </Grid>
            </MainPaper>
          </form>
        )
      }}
    </Form>
  )
}

export default Index
